import { render } from "./Navigation.vue?vue&type=template&id=9def12d8"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"
script.render = render

export default script